/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 17.11.24
 *
 */
// import './vmodal-no-animation.scss'
import '../utils/CustomPrototype.js'
import Vue from "@/entry/setupVue3.js"
import "./genogram/setupPaddleEmpty.js"
import "./genogram/dataManager-imports-light.js"
import "./genogram/globalComponentsLight.js"
import './stylesGenogram.scss'

// import "@/assets/scss/_global.scss";
// import "@/assets/scss/branding-styles.scss";
// import "@/styles/theme.scss"

import "./genogram/elementui-imports-genogram"
import analyticManager from "@/entry/genogram/setupDelayedAnalytic.js"

import VueCookies from 'vue-cookies'
import VueProgressBar from "@external/vue3-progressbar/src";
import * as ModalDialogs from 'vue3-modal-dialogs'
import BaseCookie from "@/core/js/Cookie/BaseCookie";


import ClientProfile from "@shared/Profile/ClientProfile";//hack to overcome circular dependency. we need it to ensure

import '@/fonts/fontello/css/fontello.css'
import "@/styles/_global_components_light.scss";


// import store from '../../store'
import routerFn from '../router/routerGenogram.js'

import CommonObject from "@shared/CommonObject.js";

let routerManager = routerFn(Vue.config.globalProperties.$authManager)

// import '../../fonts/fontello/css/fontello.css'
Vue.use(VueCookies);


Vue.use(VueProgressBar)
Vue.use(ModalDialogs)



CommonObject.cookies = Vue.config.globalProperties.$cookies
CommonObject.analyticManager = analyticManager
Vue.config.globalProperties.$analyticManager = analyticManager//CommonObject.analyticManager

Vue.config.globalProperties.cookie = new BaseCookie()

export {
	Vue,
	// store,
	routerManager
}
